import React from 'react';

interface PollInfoProps {
  pollCode: string;
  pollUrl: string;
}

export function PollInfo({ pollCode, pollUrl }: PollInfoProps) {
  return (
    <div className="text-center mb-8">
      <h2 className="text-2xl font-bold mb-2 dark:text-white">Poll Created!</h2>
      <p className="text-gray-600 dark:text-gray-400 mb-4">Share this poll with your group:</p>
      <div className="bg-blue-50 dark:bg-gray-700 p-4 rounded-lg mb-4">
        <p className="text-lg font-mono dark:text-gray-100">{pollCode}</p>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{pollUrl}</p>
      </div>
    </div>
  );
}